import { render, staticRenderFns } from "./IndexBasic.vue?vue&type=template&id=018271e0&"
import script from "./IndexBasic.vue?vue&type=script&lang=ts&"
export * from "./IndexBasic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports